import React from 'react'
import {Helmet} from 'react-helmet';
import StatisticContentBE from './Components/BEStatistics';
import BeHead from '../../Components/Head/BeHead';


function StatisticsBE() {
  return (
    <>
      <Helmet>
        <title>Rullier Admin</title>
      </Helmet>
      <div>
        <BeHead />
        <StatisticContentBE />
      </div>
    </>

  )
}

export default StatisticsBE